import * as React from 'react';
import { IProductListItemCard } from 'models/product/productlistitem';
import { Link } from 'react-router';
import { formatCurrency, formatInteger } from 'helpers/common';
import { PortalCheckboxField } from 'components/FormControls';

interface IProps {
	item: IProductListItemCard;
	selectedProducts?: string[];
	size?: string;
	selectProduct: any;
	productIndex?: number;
	edit?: string;

	t?: (key: string, object?: any) => string;
}

/**
 *
 * @param props
 */
export const ProductTableRow = (props: IProps) => {
	const isChecked = props.selectedProducts.find((x) => x === props.item.id) !== undefined ? true : false;
	return (
		<div className={`productTableRow ${isChecked ? 'isChecked' : ''}`}>
			<div className="cell checkboxPosition">
				<PortalCheckboxField
					input={{
						name: 'necesarry',
						checked: props.selectedProducts.find((x) => x === props.item.id) ? true : false,
						onChange: (e: any) => {
							props.selectProduct(props.item.id, e.target.checked);
						},
					}}
					type="checkbox"
				/>
				<span className="checkmark" />
			</div>
			<div className="cell number">{props.productIndex}</div>
			<div className="cell">TODO</div>
			<div className="cell title">{props.item.name}</div>
			<div className="cell">{formatCurrency(props.item.shopCurrencyKey, props.item.price)}</div>
			<div className="cell">{formatInteger(props.item.unitsInStock)}</div>
			<div className="cell">TODO</div>
			<div className="cell">TODO</div>
			<div className="cell">{props.item.published ? 'Active' : 'Draft'}</div>
			<div className="cell">
				<Link to={`/shop/${props.item.shopId}/edit/products/${props.item.variantParentId}/edit`}>{props.edit}</Link>
			</div>
		</div>
	);
};
